import { Response } from "express";

import { IResultHandler } from "./IResultHandler";

export class JsonResultHandler implements IResultHandler {
    public async processResult(result: unknown, _req: Express.Request, res: Response): Promise<void> {
        res.json(result);
    }
}
